import axios from 'services/axios';
import { RoutePaths } from '../routes/history';
import { setStorage, getStorage } from './Browser';
import { PartnerId } from './Integration';

const JOHN_DEERE_WELL_KNOWN_URL = import.meta.env.VITE_APP_JOHN_DEERE_WELL_KNOWN_URL || '';
const BASE_API_URL = import.meta.env.VITE_APP_API_URL;
const BASE_URL = window.origin;
const REDIRECT_URI = `${BASE_URL}${RoutePaths.CallbackView(PartnerId.JohnDeere).toString()}`;
const clientId = import.meta.env.VITE_APP_JOHN_DEER_CLIENT_ID || '';
const clientSecret = import.meta.env.VITE_APP_JOHN_DEER_CLIENT_SECRET;

const settings = {
  apiUrl: 'https://sandboxapi.deere.com/platform',
  callbackUrl: REDIRECT_URI,
  clientId,
  clientSecret,
  orgConnectionCompletedUrl: BASE_URL,
  scopes: 'ag1 ag2 ag3 eq1 eq2 org1 org2 files offline_access',
  state: 'test',
  wellKnown: JOHN_DEERE_WELL_KNOWN_URL,
};

export const redirect_to_oauth_portal = async () => {
  try {
    const response: any = await axios.get(JOHN_DEERE_WELL_KNOWN_URL);
    if (response) {
      const params = new URLSearchParams({
        client_id: settings.clientId,
        response_type: 'code',
        scope: settings.scopes,
        redirect_uri: settings.callbackUrl,
        state: settings.state,
      });
      const url = `${response.data.authorization_endpoint}?${params.toString()}`;
      window.location.replace(url);
    }
  } catch (error: any) {
    console.error('failed to pass to JD', error.message);
    return error;
  }
};

export const handle_org_selection = async (uri: string) => {
  const params = new URLSearchParams({
    redirect_uri: settings.callbackUrl,
  });
  const url = `${uri}?${params.toString()}`;
  window.location.assign(url);
};

export const get_orgs = async (user_id: string, org_id: string) => {
  const organizations = await getJohnDeereOrganizations(user_id, org_id);
  const have_redirected = getStorage('johndeere_connect_redirect');
  if (organizations?.error_type) return organizations;
  let connect_link = null;
  const returnable_orgs: any[] = [];
  organizations?.forEach((org: any) => {
    const org_link = org.links.find((con_link: any) => con_link.rel === 'connections');
    if (org_link) {
      connect_link = org_link.uri;
    } else {
      returnable_orgs.push(org);
    }
  });
  if (!connect_link || have_redirected) return returnable_orgs;
  setStorage('johndeere_connect_redirect', true);
  handle_org_selection(connect_link);
  return [];
};

export const getJohnDeereOrganizations = async (user_id: string, org_id: string) => {
  try {
    const response: any = await axios.request({
      method: 'GET',
      url: `${BASE_API_URL}/valet/v2/johndeere-orgs`,
      params: {
        user_id,
        org_id,
      },
    });

    return response?.data?.organizations;
  } catch (err: any) {
    console.error('GET John Deere Organizations:', err);
    return err;
  }
};
